export default __webpack_public_path__ + "static/media/seveneleven.8cde626c.jpeg";